import { all } from "redux-saga/effects";
import {
  schemeListWatcher,
  schemeGetWatcher,
  schemeCreateWatcher,
  schemeUpdateWatcher,
  schemePauseWatcher,
  schemeResumeWatcher,
  schemeArchiveWatcher,
  schemeReorderWatcher,
  schemeEvaluateWatcher,
} from "../scheme-saga";

export default function* schemeRootSaga() {
  yield all([
    schemeListWatcher(),
    schemeGetWatcher(),
    schemeCreateWatcher(),
    schemeUpdateWatcher(),
    schemePauseWatcher(),
    schemeResumeWatcher(),
    schemeArchiveWatcher(),
    schemeReorderWatcher(),
    schemeEvaluateWatcher(),
  ]);
}
